import React from "react";

const LoadingPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#020617]">
      <div className="flex flex-col items-center animate-fadeIn">
        {/* Outer Glow Circle */}
        <div className="relative w-20 h-20 flex items-center justify-center">
          <div className="absolute w-full h-full rounded-full border-4 border-white/10 animate-pulse"></div>

          {/* Spinning Ring */}
          <div className="absolute w-full h-full rounded-full border-4 border-transparent border-t-blue-400 border-r-blue-500 animate-spin"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
